module.exports = __webpack_public_path__ + "static/img/4594_phase_function_Paper_PointsHejduk_Prediction.f39290c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4594_phase_function_Paper_PointsHejduk_Prediction.png
// module id = M1bb
// module chunks = 0